
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const rp236 = {
    label: "Freeze A/C List",
    pageLabel: "Freeze A/C List",
    starting: true,
    url: "rp236",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Region",
            name: "",
            description: "Enter Region" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Region",
            name: "Region",
            description: "Region"
          }, 
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Regular",
                value: "Regular"
              },
              {
                label: "Associated",
                value: "Associated"
              },
              {
                label: "Nominal(B class)",
                value: "Nominal(B class)"
              },
              {
                label: "All Members",
                value: "All Members"
              },
              {
                label: "No Members",
                value: "No Members"
              },
              {
                label: "All",
                value: "All"
              },
             ],
            placeHolder: "",
            name: "MemberType",
            description: "Enter MemberType"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Marathi Name",
            name: "Print Marathi Name",
            description: "Print Marathi Name"
          } ,
        
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Parent Branch",
            name: "",
            description: "Enter Parent Branch" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Parent Branch",
            name: "ParentBranch",
            description: "Parent Branch"
          }, 
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Main Branch",
            name: "",
            description: "Enter Main Branch" 
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            options: [
              {
                label: "KYC Done",
                value: "KYC Done"
              },
              {
                label: "KYC Not Done",
                value: "KYC Not Done"
              },
              
             ],
            placeHolder: "",
            name: "KYCType",
            description: "Enter KYCType"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Without Name",
            name: "Without Name",
            description: "Without Name"
          } ,
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product Group",
            name: "",
            description: "Enter Product Group" 
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Deposite",
                value: "Deposite"
              },
              {
                label: "Loan",
                value: "Loan"
              },
              {
                label: "Bank",
                value: "Bank"
              },
              {
                label: "Other",
                value: "Other"
              },
              {
                label: "Internal",
                value: "Internal"
              },
              
             ],
            placeHolder: "",
            name: "ProductGroup",
            description: "Enter ProductGroup"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            options: [
              {
                label: "With PAN",
                value: "With PAN"
              },
              {
                label: "Without PAN",
                value: "Without PAN"
              },
              
             ],
            placeHolder: "",
            name: "PANType",
            description: "Enter PANType"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Mobile No.",
            name: "PrintMobileNo",
            description: "Print Mobile No"
          } ,
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product Type",
            name: "",
            description: "Enter Product Type" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Product Type",
            name: "ProductType",
            description: "Product Type"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            options: [
              {
                label: "With AADAHAR",
                value: "With AADAHAR"
              },
              {
                label: "Without AADAHAR",
                value: "Without AADAHAR"
              },
              
             ],
            placeHolder: "",
            name: "AADAHARType",
            description: "Enter AADAHARType"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Member No.",
            name: "PrintMemberNo",
            description: "Print Member No"
          } ,
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product",
            name: "",
            description: "Enter Product" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Product",
            name: "Product",
            description: "Product"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Low",
                value: "Low"
              },
              {
                label: "Medium",
                value: "Medium"
              },{
                label: "High",
                value: "High"
              },
              
             ],
            placeHolder: "",
            name: "Typevale",
            description: "Enter Typevale"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print KYC Flag",
            name: "PrintKYCFlag",
            description: "Print KYC Flag"
          } ,
          
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "As On Date",
            name: "",
            description: "Enter As On Date"
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "From DAte",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "AsOnDate",
            description: "Enter As On Date"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            options: [
              {
                label: "No Signature",
                value: "No Signature"
              },
              {
                label: "Single Signature",
                value: "Single Signature"
              },{
                label: "Multiple Signature",
                value: "Multiple Signature"
              },
              
             ],
            placeHolder: "",
            name: "SignatureType",
            description: "Enter SignatureType"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print ADHAR",
            name: "PrintADHAR",
            description: "Print ADHAR"
          } ,         
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Account Number From",
            name: "",
            description: "Enter Account Number From" 
          }, 
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Account No From",
            name: "AccountNumberFrom",
            description: "Enter Account NumberFrom"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Account No To",
            name: "AccountNumberTo",
            description: "Enter Account To"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print PAN",
            name: "PrintPAN",
            description: "Print PAN"
          } ,  
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Credit/Debit Type",
            name: "",
            description: "Enter Credit/Debit Type" 
          },        
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Credit",
                value: "Credit"
              },
              {
                label: "Debit",
                value: "Debit"
              },
              {
                label: "Both",
                value: "Both"
              },
              {
                label: "Nill Balance",
                value: "Nill Balance"
              }
             ],
            placeHolder: "Credit/Debit Type",
            name: "Credit_DebitType",
            description: "Enter Credit/Debit Type"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter " 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Risk Category",
            name: "PrintRiskCategory",
            description: "With Print Risk Category"
          } ,
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Amount From To",
            name: "",
            description: "Enter Amount From To" 
          }, 
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Amount From",
            name: "AmountFrom",
            description: "Enter AmountFrom"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "AmountTo",
            name: "AmountTo",
            description: "Enter Amount To"
          }, 
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Details",
            name: "Details",
            description: "Details"
          } ,
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Account Type",
            name: "",
            description: "Enter Account Type" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Account Type",
            name: "AccountType",
            description: "Account Type"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Top No Of Accounts",
            name: "",
            description: "Enter Top No Of Accounts" 
          }, 
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Top No Of Accounts",
            name: "TopNoOfAccounts",
            description: "Enter Top No Of Accounts"
          },     
      
    ]
  }
  export default rp236;